import {
  assignChatToUser,
  assignMultipleChatsToUser,
} from '../requests/assign-chat';
import { unassignChat, unassignMultipleChats } from '../requests/unassign-chat';
interface AssignUserUseCaseArgs {
  data: {
    chatId: string;
    customerId: string;
    userId?: string;
  };
}

export default async function assignUserUseCase({
  data,
}: AssignUserUseCaseArgs) {
  if (!data.userId) return unassignChat(data.chatId);

  return assignChatToUser(data.chatId, data.customerId, data.userId);
}

export async function assignMultipleChatsToUserUseCase(
  chatIds: string[],
  userId: string
): Promise<{}> {
  return assignMultipleChatsToUser(chatIds, userId);
}

export const unassignMultipleChatsUseCase = async (
  chatIds: string[]
): Promise<{}> => {
  return unassignMultipleChats(chatIds);
};
